module.exports = __webpack_public_path__ + "c7617e3cdcce99e7de7dff12f0bf540b.MP3";